import { useState, useCallback, useRef } from 'react';
import API_BASE_URL from '../config/api';

const useOpenAIChat = () => {
    const [response, setResponse] = useState('');
    const [streamResponse, setStreamResponse] = useState('');
    const messagesRef = useRef([
        { role: "system", content: "Du bist ein Experte für Vokabeltraining und hilfst deinem Schüler besser zu lernen, gemacht Fehler zu verstehen und diesen Fehler in Zukunft zu vermeiden." }
    ]);
    const isProcessingRef = useRef(false);

    const getResponse = useCallback(async (prompt) => {
        if (isProcessingRef.current) {
            console.log('Already processing a request');
            return;
        }

        try {
            isProcessingRef.current = true;
            setStreamResponse('');
            
            const messagesToSend = [
                ...messagesRef.current,
                { role: "user", content: prompt }
            ];

            const res = await fetch(`${API_BASE_URL}/api/ai/chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ 
                    messages: messagesToSend,
                    stream: false 
                })
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.error || 'Chat request failed');
            }

            const data = await res.json();
            const fullResponse = data.content;

            setResponse(fullResponse);
            setStreamResponse(fullResponse);
            
            messagesRef.current = [
                ...messagesRef.current,
                { role: "user", content: prompt },
                { role: "assistant", content: fullResponse }
            ];

            return fullResponse;

        } catch (error) {
            console.error('Error fetching response from AI:', error);
            throw error;
        } finally {
            isProcessingRef.current = false;
        }
    }, []);

    return { 
        response, 
        streamResponse, 
        getResponse,
    };
};

export default useOpenAIChat;
